import { StyleTypography, StyleUserInfoWrapper } from '@components/styles'
import { format } from 'date-fns'

const TableDate = ({ date, hasTime = true }: any) => {
  return (
    <StyleUserInfoWrapper>
      {date ? (
        <>
          <StyleTypography customStyle={{ width: 'max-content' }}>
            {format(date, 'MMM dd, yyyy')}
          </StyleTypography>
          {!!hasTime && (
            <StyleTypography color="grey300">
              {format(date, 'HH:MM aa')}
            </StyleTypography>
          )}
        </>
      ) : (
        '-'
      )}
    </StyleUserInfoWrapper>
  )
}

export default TableDate
